import EventSeatIcon from "@mui/icons-material/EventSeat";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctoralSeats from "./List";
import CreateDoctoralSeat from "./Create";
import EditDoctoralSeat from "./Edit";
import ShowDoctoralSeat from "./Show";

export const resources = {
  isMenu: true,
  icon: <EventSeatIcon />,
  name: `${DoctoralServicePath}doctoral-seats`,
  title: "Докторантски места",
  list: <ListDoctoralSeats />,
  create: <CreateDoctoralSeat />,
  createPermission: permissions.canCreateDoctoralSeats,
  edit: <EditDoctoralSeat />,
  editPermission: permissions.canUpdateDoctoralSeats,
  show: <ShowDoctoralSeat />,
  permission: permissions.canPreviewDoctoralSeats,
};
